import { Link, useNavigate } from "react-router-dom";
import { userLogout } from "../../../services/AuthService";
import { HSTSToast } from "../../../utils/hstsToast";
import { useUser } from "../../../utils/userProvider";

export const TopHeader = ({ sidebarOpen, setSidebarOpen, windowWidth }) => {
  const navigator = useNavigate();
  const { logout } = useUser();
  const logoutHandler = async () => {
    try {
      await userLogout(); // Call backend logout to delete cookie
      logout(); // Clear context

      navigator("/");
    } catch (error) {
      console.error("Logout error:", error);
      HSTSToast("error", "Logout failed");
    }
  };
  return (
    <header className="bg-white border-bottom sticky-top">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between py-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-outline-secondary d-md-none"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              title="Toggle Sidebar"
            >
              <i className="fas fa-bars"></i>
            </button>
            <h6 className="mb-0 fw-bold d-md-none">
              HEET Students Tracking System (HETRAS)
            </h6>
          </div>

          <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
            <div className="container-fluid">
              <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
                <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none"></li>

                <li className="nav-item topbar-user dropdown hidden-caret">
                  <Link
                    className="dropdown-toggle profile-pic"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="avatar-sm">
                      <img
                        src="/assets/img/c.png"
                        alt="..."
                        className="avatar-img rounded-circle"
                      />
                    </div>
                    <span className="profile-username">
                      <span className="op-7 me-2">Welcome,</span>
                      <span className="fw-bold">Administrator</span>
                    </span>
                  </Link>
                  <ul className="dropdown-menu dropdown-user animated fadeIn">
                    <div className="dropdown-user-scroll scrollbar-outer">
                      <li>
                        <Link to="/admin/password" className="dropdown-item">
                          Account Setting
                        </Link>
                        <div className="dropdown-divider"></div>
                        <p
                          onClick={logoutHandler}
                          className="dropdown-item zis-ponter"
                        >
                          Logout
                        </p>
                      </li>
                    </div>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};
